module.exports = __webpack_public_path__ + "img/start_position_icon.6a43d2ec.svg";